/**
 * requireValue.js v1.0.0 - 2026-10-09
 *
 * Reads a required numeric parameter from constants or scenario data and throws, with the path,
 * when it is absent. Replaces `value || <literal>` fallbacks in calculation code
 * (APP_RULES Rule 6.1 / 13.3; backlog CALC-010): a missing parameter must fail loudly, not be
 * replaced by a number nobody can find in the constants files.
 *
 * Version history:
 *   v1.0.0 (2026-10-09): initial release
 */

/**
 * @param {*} value - value to check
 * @param {string} where - calling function, e.g. 'survivalModule.calculateComprehensiveDOW'
 * @param {string} path - where the value should come from, e.g. 'TRIAGE_CATEGORIES.T4_EXPECTANT.mortality_rate'
 * @returns {number} the value, unchanged
 */
export function requireNumber(value, where, path) {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    throw new Error(`${where}: ${path} is absent or not a finite number (got: ${value}). Check the constants file or the saved scenario.`);
  }
  return value;
}
